import script from "./Borrower.vue?vue&type=script&setup=true&lang=ts"
export * from "./Borrower.vue?vue&type=script&setup=true&lang=ts"

import "./Borrower.vue?vue&type=style&index=0&id=42ed9244&scoped=true&lang=css"
import "@/assets/css/certifications-and-disbursements.css?vue&type=style&index=1&id=42ed9244&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ed9244"]])

export default __exports__